import React from "react";
import { BlockStack, LegacyCard as Card, InlineStack, OptionList, Popover, RadioButton, Text } from "@shopify/polaris";
import { renderDestination } from "app/shipping/modules/provider/features/subFeatures/advance/offers/propsType";

const RenderOfferDestination = (props) => {
  const {
    checkedDestination,
    renderRegion,
    handleDestination,
    popoverActive,
    activator,
    handleShippingDestination,
    destinationData,
    destinationCodes,
    togglePopoverActive,
    cms,
  } = props;

  return (
    <Card title={cms("label.destination")} sectioned>
      <BlockStack>
        <RadioButton
          label={cms("modal.offer.add.section.destination.label.allDestination")}
          helpText={cms("modal.offer.add.section.destination.caption.allDestination")}
          checked={checkedDestination}
          id="all-destinations"
          name="all-destinations"
          onChange={handleDestination}
        />
        <RadioButton
          label={cms("modal.offer.add.section.destination.label.selectedDestinations")}
          helpText={cms("modal.offer.add.section.destination.caption.selectedDestination")}
          id="selected-destinations"
          name="selected-destinations"
          checked={!checkedDestination}
          onChange={handleDestination}
        />
        {!checkedDestination && [
          <Popover active={popoverActive} activator={activator} onClose={togglePopoverActive} preferredAlignment="left">
            <OptionList
              onChange={(value) => {
                handleShippingDestination(value);
              }}
              sections={destinationData}
              selected={destinationCodes}
              allowMultiple
            />
          </Popover>,
          <Text as="span">{renderRegion()}</Text>,
        ]}
      </BlockStack>
    </Card>
  );
};

RenderOfferDestination.propTypes = renderDestination.type;

export default RenderOfferDestination;
